import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';

import { transformOptionsByPath } from '@openx/components-deal/lib/utils/transformOptionsByPath.ts';
import type { HierarchyItem } from '@openx/types/hierarchyItem.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useAgenciesOptionsFetch: DealProviderConfig['useAgenciesOptionsFetch'] = () => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.agency_salesforce_id',
    },
    fetchPolicy: 'network-only',
  });

  const { list, mapById } = useMemo(() => transformOptionsByPath(optionsByPath), [optionsByPath]);

  return {
    list: list as HierarchyItem[],
    loading,
    mapById: mapById as Record<string, HierarchyItem>,
    refetch,
  };
};
